import { DocumentTypeData } from "./documentTypeData";

/**
* Пользовательский документ
*/
export class UserDocumentData {
  /**
  * Идентификатор документа в БД БЛ
  */
  public Id: number = 0;

  /**
  * Данные документа
  */
  public Number: string = "";

  /**
  * Название
  */
  public Name: string = "";

  /**
  * Тип документа
  */
  public Type: DocumentTypeData = new DocumentTypeData();

  /**
  * Конструктор с загрузкой данных из JObject.
  */
  public constructor(src: any = null) {
    if (src == null)
      return;

    this.Id = src.Id ?? 0;
    this.Number = src.Number ?? "";
    this.Name = src.Name ?? "";

    this.Type = new DocumentTypeData(src.Type);
  }

  public copy(data: UserDocumentData) {
    this.Id = data.Id;
    this.Number = data.Number;
    this.Name = data.Name;
    if(data.Type)
      this.Type.copy(data.Type);
  }
}

